import type { DeepString } from "@/lib/i18n";

/**
 * CFilesToDownload - polskie tlumaczenia (Pliki do pobrania).
 */
export const pl = {
  emptyData: "Brak danych do wyświetlenia.",
  emptyList: "Brak plików w tej sekcji.",
  categoryLabel: "Kategoria",
  allCategories: "Wszystkie kategorie",
  back: "<- Wróć",
  download: "Pobierz plik",
  requiresLogin: "Tylko dla zalogowanych",
  requiresAdmin: "Tylko dla administratorów",
  fileFallbackExt: "PLIK",
  units: {
    kb: "KB",
    mb: "MB",
  },
} as const;

export type CFilesToDownloadTranslations = DeepString<typeof pl>;
